<template>
  <div class="category-div staff-student-supervision">
    <v-row>
      <v-col cols="12">
        <div class="staff-student-supervision-category-section">
          <v-icon
            id="staff-student-supervision--toggle-supervision--icon"
            @click.stop="toggleSupervision()"
          >
            {{ supervisionContentDisplayed ? 'mdi-chevron-down' : 'mdi-chevron-left' }}
          </v-icon>
          <span
            id="staff-student-supervision--toggle-supervision--label"
            class="name"
            @click.stop="toggleSupervision()"
            >Staff and Student Supervision</span
          >
        </div>
      </v-col>
    </v-row>
    <div
      :hidden="!supervisionContentDisplayed"
      class="staff-student-supervision-sub-category-section"
    >
      <v-row no-gutters class="flex-wrap">
        <v-col cols="12">
          <v-label class="form-label safe-trip-font">
            How many staff / supervisors attending?
          </v-label>
          <v-text-field
            id="staff-student-supervision--staff-supervisor-attendance-count"
            v-model="staffSupervisorAttendanceCount"
            :disabled="!formControlEnabled"
            variant="solo"
            class="name-textbox excursion-input"
            placeholder="Enter the amount of staff / supervisors attending"
            density="compact"
            @keyup="formatStaffSupervisorAttendanceCount($event)"
          />
        </v-col>
      </v-row>
      <v-row no-gutters class="flex-wrap">
        <v-col cols="12" class="excursion-detail-text">
          <v-label class="form-label safe-trip-font"> How many students attending? </v-label>
          <v-text-field
            id="staff-student-supervision--student-attendance-count"
            v-model="studentAttendanceCount"
            :disabled="!formControlEnabled"
            variant="solo"
            class="name-textbox excursion-input"
            placeholder="Enter the amount of students attending"
            density="compact"
            @keyup="formatStudentAttendanceCount($event)"
          />
        </v-col>
      </v-row>
      <v-row no-gutters class="flex-wrap">
        <v-col cols="12" class="excursion-detail-text">
          <v-label class="form-label safe-trip-font"
            >Calculated Staff to Student Supervision Ratio</v-label
          >
          <v-text-field
            id="staff-student-supervision--staff-to-student-ratio"
            v-model="staffToStudentRatio"
            disabled
            variant="solo"
            class="name-textbox excursion-input"
            placeholder="e.g. 1:1.10"
            density="compact"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/mutationTypes';

export default {
  props: ['formControlEnabled'],
  data() {
    return {
      supervisionContentDisplayed: true
    };
  },
  computed: {
    staffSupervisorAttendanceCount: {
      get() {
        return this.$store.state.common.excursionDc.staffSupervisorAttendanceCount;
      },
      set(value) {
        this.$store.commit(types.COMMON_SET_EXCURSION_DC_STAFF_SUPERVISOR_ATTENDANCE_COUNT, value);
      }
    },
    studentAttendanceCount: {
      get() {
        return this.$store.state.common.excursionDc.studentAttendanceCount;
      },
      set(value) {
        this.$store.commit(types.COMMON_SET_EXCURSION_DC_STUDENT_ATTENDANCE_COUNT, value);
      }
    },
    staffToStudentRatio: {
      get() {
        return this.$app.excursionCommon.getStaffToStudentRatio(
          this.staffSupervisorAttendanceCount,
          this.studentAttendanceCount
        );
      }
    }
  },
  methods: {
    toggleSupervision() {
      this.supervisionContentDisplayed = !this.supervisionContentDisplayed;
      this.$emit('toggleSupervision', this.supervisionContentDisplayed);
    },
    getNumberValue(value) {
      const numberValue = value.replace(/[^\d]+/g, '');
      const maxValue = 9999;
      const minValue = 0;
      let returnValue;

      if (numberValue === '') {
        returnValue = '';
      } else if (numberValue <= minValue) {
        returnValue = minValue;
      } else if (maxValue < numberValue) {
        returnValue = maxValue;
      } else {
        returnValue = numberValue;
      }

      return returnValue;
    },
    formatStaffSupervisorAttendanceCount(e) {
      this.staffSupervisorAttendanceCount = this.getNumberValue(e.target.value);
    },
    formatStudentAttendanceCount(e) {
      this.studentAttendanceCount = this.getNumberValue(e.target.value);
    }
  }
};
</script>
<style scoped>
.staff-student-supervision-category-section {
  font-size: 14px;
  margin-bottom: 10px;
}
</style>
